// Configurações de ambiente
export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',
  ENV: process.env.REACT_APP_ENV || 'development',
};
